import React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { __, dateTimeFrom } from '../../core/utils';
import styles from '../../styles/flyouts/files/FileFlyout.scss';

const History = ({ history, collapsed }) => (
  <div className={classNames(styles.sectionContent, collapsed && styles.collapsed)}>
    {_.isEmpty(history) ? (
      <div className={styles.empty}>
        {__('files.flyout.no-history', {}, 'No history yet.')}
      </div>
    ) : (
      _.map(history, (row, index) => (
        <div className={styles.historyRow} key={index}>
          <div>
            <strong>{row.title}</strong>
            <span>
              {_.filter([row.user, dateTimeFrom(row.created_at)]).join(' · ')}
            </span>
          </div>
          {row.content && <p>{row.content}</p>}
        </div>
      ))
    )}
  </div>
);

export default History;
